import { Dispatch } from "redux";
import { registerProvider } from "@/providers";

export function refreshWallet(
  dispatch: Dispatch,
  provider: any,
  user: any,
  chainId: number,
  canTransact: boolean
): void {
  dispatch({
    type: "SET_PROVIDER",
    payload: registerProvider(provider),
  });
  dispatch({
    type: "SET_USER",
    payload: user,
    canTransact: canTransact,
  });
  dispatch({
    type: "SET_CHAIN_ID",
    payload: chainId,
  });
}

export function shortAddress(address: string | null | undefined): string {
  if (!address) return "";
  return address.substring(0, 6) + "..." + address.slice(-4);
}
